export default __webpack_public_path__ + "static/media/help.fb9b0371.svg";